// import { initializeApp } from "firebase/app";
// import { getMessaging } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "XXXX",
//   authDomain: "XXXX.firebaseapp.com",
//   projectId: "XXXX",
//   messagingSenderId: "XXXX",
//   appId: "XXXX"
// };

// const app = initializeApp(firebaseConfig);

// export const messaging = getMessaging(app);

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getMessaging } from "firebase/messaging";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBloCGO7GTyMP9LFdfnvV_AGt9I8MDxcFU",
//   authDomain: "wims-ee904.firebaseapp.com",
//   projectId: "wims-ee904",
//   storageBucket: "wims-ee904.firebasestorage.app",
//   messagingSenderId: "674338953387",
//   appId: "1:674338953387:web:f89d0c6c75734d87bebfee",
//   measurementId: "G-N10S2YGTYH"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// export const messaging = getMessaging(app);


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCPXlURk13cXP5N9U8zCRugAO-D8y_f1oY",
  authDomain: "mr-paymaster.firebaseapp.com",
  projectId: "mr-paymaster",
  storageBucket: "mr-paymaster.firebasestorage.app",
  messagingSenderId: "74081018921",
  appId: "1:74081018921:web:d35ea3a8ded716396d6838",
  measurementId: "G-603633572L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
 export const messaging = getMessaging(app);